module.exports = __webpack_public_path__ + "img/701.378c9e60.jpg";